import httpUtils from '@/utils/http-utils';
import i18n from '@/plugins/vue-i18n';

const baseRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}/regions`,
  requesterType: 'CMS_WEB_SERVICE',
};
const regionApiReqNotification = httpUtils.createRequester(baseRequesterOptions);
const regionApiReqErrorHandling = httpUtils.createRequester(baseRequesterOptions, 'errorHandling');

const getRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return regionApiReqErrorHandling;
  }

  return regionApiReqNotification;
};

class RegionApi {
  fetchRegions(errorManagementType) {
    return getRequester(errorManagementType)
      .get('/', {
        headers: {
          'accept-language': i18n.locale,
        },
      }).then(res => res && res.data);
  }
}

export default new RegionApi();
